<div class="last-update-item">
  <app-avatar [name]="lastUpdate.name" size="large" />
  <div class="last-update-content-wrapper">
    <div class="last-update-header">
      <span class="client-name">{{ lastUpdate.name }}</span>
    </div>
    <div class="last-update-content">
      <div class="last-update-action">
        <mat-icon class="check-icon material-icons-outlined">
          check_circle
        </mat-icon>
        {{ lastUpdate.lastUpdatedSection }}
      </div>
      <div class="last-update-timestamp">{{ lastUpdate.lastUpdatedText }}</div>
    </div>
  </div>
</div>
